import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ButtonGrid = styled(Grid)`
  display: flex;

  > *:not(:first-child) {
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;
